import React, {Component} from 'react';
import GaugeArea from './GaugeArea';
import {greens, blues} from './styles';

const gaugesStyle = {
    'backgroundColor': '#fff',
    'border': '1px solid',
    'borderColor': 'rgba(0,0,0,.0625)',
    'height': '440px',
    padding: '20px'
};

export default class Gauges extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      value: 1,
    };
  }

  componentWillReceiveProps(nextProps) {
      if (nextProps.catchmentId === undefined) {
          return;
      }
    fetch(`api/gaugedata/getdata/${nextProps.catchmentId}`)
      .then(response => response.json())
      .then(data => {
        this.setState({ spei: data.spei, rain: data.rainfall, pet: data.pet })
      });
  }

  render() {
      let name = 'Click on a catchment';
      let res = "";
      if (this.props.catchmentName) {
          name = `Catchment: ${this.props.catchmentName}`;
          res = (<div style={gaugesStyle}>
              <h3>{name}</h3>
              <div>
                  <GaugeArea title={'SPEI'} data={this.state.spei} colors={greens}/>
                  <GaugeArea title={'Rainfall'} data={this.state.rain} colors={blues}/>
                  <GaugeArea title={'PET'} data={this.state.pet} colors={blues}/>
              </div>
          </div>);
      }
      return <div>{res || <h3>{name}</h3>}</div>;
  }
}


// WEBPACK FOOTER //
// ./src/components/Gauges.jsx